import type { BooleanAlgebraOperation, BooleanOperationDeclaration } from '@/adapters/primitive/_contract/boolean/operation';

export const BOOLEAN_OPERATIONS = {
    'logical-and': { operation: 'logical-and', paths: [{ pathKey: 'true-true', requiredInputs: [true, true] }] },
    'logical-nand': {
        operation: 'logical-nand',
        paths: [
            { pathKey: 'false-false', requiredInputs: [false, false] },
            { pathKey: 'mixed', requiredInputs: [true, false] },
        ],
    },
    'logical-xor': { operation: 'logical-xor', paths: [{ pathKey: 'mixed', requiredInputs: [true, false] }] },
    'logical-xnor': {
        operation: 'logical-xnor',
        paths: [
            { pathKey: 'true-true', requiredInputs: [true, true] },
            { pathKey: 'false-false', requiredInputs: [false, false] },
        ],
    },
    'logical-or': {
        operation: 'logical-or',
        paths: [
            { pathKey: 'true-true', requiredInputs: [true, true] },
            { pathKey: 'mixed', requiredInputs: [true, false] },
        ],
    },
    'logical-nor': { operation: 'logical-nor', paths: [{ pathKey: 'false-false', requiredInputs: [false, false] }] },
    'logical-not': { operation: 'logical-not', paths: [{ pathKey: 'false', requiredInputs: [false] }] },
} as const satisfies Record<BooleanAlgebraOperation, BooleanOperationDeclaration>;